export const adaptAllMessageForLocalStorage = ({ allMessages, webchatKey }) => {
  const finalMessages = allMessages;
  finalMessages.forEach((m, i) => {
    const { message } = m;
    if (message) {
      let { actions } = message;
      if (typeof actions === "string") {
        actions = JSON.parse(actions);
      }
      actions.forEach((action, j) => {
        const { type } = action;
        if (type === "wait") {
          actions[j].status = "skip";
        } else {
          actions[j].status = "visible";
        }
      });
      finalMessages[i].message.actions = actions;
    }
    finalMessages[i].webchatKey = webchatKey;
  });
  return finalMessages;
};

export default {
  adaptAllMessageForLocalStorage,
};
